export default (state) => {
  return Object.assign({}, state, {});
};
